<template>
  <tk-image :src="avatar" :width="size" :height="size" v-if="avatar"></tk-image>
  <div class="text-avatar" :style="avatarStyle" v-else>{{this.avatarString}}</div>
</template>
<script>
const colors = ['#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e', '#16a085', '#27ae60', '#2980b9', '#8e44ad', '#2c3e50', '#f1c40f', '#e67e22', '#e74c3c', '#95a5a6', '#f39c12', '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d']
export default {
  name: 'avatar',
  computed: {
    avatarStyle () {
      let style = {
        width: this.size + 'px',
        height: this.size + 'px',
        lineHeight: this.size + 'px',
        fontSize: Math.round(this.size / 1.8) + 'px'
      }
      if (this.avatarString) {
        style.backgroundColor = colors[(this.avatarString.charCodeAt(0)) % 19] || colors[0]
      }
      return style
    },
    avatar () {
      if (!this.user || !Object.keys(this.user).length) return 'http://moke-store.oss-cn-beijing.aliyuncs.com/cc857bbd-ae4b-4dd2-8398-2d03277c7d24.png'
      if (!this.isAdmin && this.user.business_title) return this.businessAvatar
      if (this.isAdmin && !this.$store.state.devMode && this.user.business_title) return this.businessAvatar
      return this.user.avatar
    },
    businessAvatar () {
      if (this.user.business_title) return require(`../assets/images/${this.user.business_title}.png`)
      return 'http://moke-store.oss-cn-beijing.aliyuncs.com/cc857bbd-ae4b-4dd2-8398-2d03277c7d24.png'
    },
    name () {
      return this.user && this.user.username
    },
    avatarString () {
      if (!this.name) return ''
      return this.name[0]
    }
  },
  props: {
    user: Object,
    size: {
      type: Number,
      default: 40
    }
  }
}
</script>
<style lang="scss" scoped>
.text-avatar {
  color: white;
  text-align: center;
  text-transform: uppercase;
}
</style>
